import { getLegalTextBySponsor } from "../../../functions/functions";
import './legal.sass';

/**
 * Muestra el texto legal correspondiente al patrocinador si existe.
 * Evita renderizar si el texto está vacío.
 */
export default function Legal({ patrocinador = "" }) {
  const legalText = getLegalTextBySponsor(patrocinador);

  if (!legalText) return null;

  return (
    <div className="container-legal" data-nosnippet>
      <p className="text-legal">{legalText}</p>
    </div>
  );
}